/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Warm_Finch_GazeInputs */

const en_deep_warm_finch_gaze = /** @type {(inputs: Deep_Warm_Finch_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribute`)
};

const de_deep_warm_finch_gaze = /** @type {(inputs: Deep_Warm_Finch_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmal`)
};

/**
* | output |
* | --- |
* | "Attribute" |
*
* @param {Deep_Warm_Finch_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_warm_finch_gaze = /** @type {((inputs?: Deep_Warm_Finch_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Warm_Finch_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_warm_finch_gaze(inputs)
	return de_deep_warm_finch_gaze(inputs)
});